// ─── Il telefono del socio, scritto come viene ───────────────────────────────
//
// 🗣️ Voce 25 (25/09/2026, dal mockup approvato): *«se non lo formatto bene mi dà
// errore. E poi se non ci metto il +39 avanti mi dà errore»*.
//
// ⭐ Il numero si scrive come viene. Il server lo ripulisce prima di
// controllarlo (`normalizzaTelefono`, ⇒ `@pmo/shared/soci.ts`), e sotto la
// casella si legge **già mentre si scrive** come verrà salvato. È la stessa
// funzione del server, quindi quello che si legge è quello che si salva.

import { useId } from 'react';
import { normalizzaTelefono } from '@pmo/shared';

export function CampoTelefono({
  etichetta,
  value,
  onChange,
}: {
  etichetta: string;
  value: string;
  onChange: (valore: string) => void;
}): React.JSX.Element {
  const vuoto = value.trim() === '';
  const ripulito = normalizzaTelefono(value);
  const riga = useId();
  return (
    <label className="campo">
      <span>{etichetta}</span>
      {/* ♿ Il nome della casella resta l'etichetta: la riga sotto sta dentro il
          <label>, e senza `aria-label` il nome cambierebbe a ogni cifra. La
          riga è la sua descrizione. */}
      <input
        aria-label={etichetta}
        aria-describedby={riga}
        inputMode="tel"
        autoComplete="tel"
        value={value}
        onChange={(e) => onChange(e.target.value)}
      />
      <small id={riga} className={`come-si-salva${vuoto ? '' : ripulito ? ' va' : ' no'}`} aria-live="polite">
        {vuoto ? null : ripulito ? (
          <>
            Si salva come <code>{ripulito}</code>
          </>
        ) : (
          'Così non è un numero di telefono: servono solo cifre, almeno sei.'
        )}
      </small>
    </label>
  );
}
